<template>
  <button class="btn btn-default"
          :class="[favStatus ? 'fav-active' : 'fav-inactive', {'float-right' : !$mq.phone} ]"
          @click="saveFavProfessional(professional.id)">
    <i class="fa-heart" :class="favStatus ? 'fas' : 'far'"></i>
  </button>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: ['professional'],
    data () {
      return {
        favStatus: false
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      })
    },
    watch: {
      professional () {
        this.setFavStatus()
      }
    },
    methods: {
      saveFavProfessional (professionalId) {
        const submitData = {
          user_id: this.user.id,
          professional_id: professionalId
        }
        const updateData = {
          professional_id: professionalId,
          is_favorited_professional: true
        }
        this.favStatus = !this.favStatus
        if (this.favStatus) {
          this.$store.dispatch('user/ADD_FAVORITE_PROFESSIONAL', submitData)
          this.$store.commit('booking/UPDATE_FAVORITE_PROFESSIONAL', updateData)
        } else {
          this.$store.dispatch('user/DELETE_FAVORITE_PROFESSIONAL', submitData)
          updateData.is_favorited_professional = false
          this.$store.commit('booking/UPDATE_FAVORITE_PROFESSIONAL', updateData)
        }
      },
      setFavStatus () {
        this.favStatus = this.professional.is_favorited_professional
      }
    },
    mounted () {
      this.setFavStatus()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/components/ButtonFavoriteProfessional.vue